module.exports = __webpack_public_path__ + "img/pitch-plan.505f260b.jpg";